import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    width: '100%',
    padding: '40px 20px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    background: '#FF7A01',

    '& svg ': {
      color: '#fff',
    },
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',

    '& span': {
      margin: 0,
      padding: 0,
      fontWeight: 500,
      textTransform: 'uppercase',
      color: '#fff',

      fontSize: '18px',
    },
    '& strong': {
      fontWeight: 400,
      color: '#fff',

      fontSize: '12px',
      marginTop: '10px',
    },
  },
  infosHeader: {
    display: 'flex',
    '& svg': {
      maxHeight: '15px',
    },
  },
  logo: {
    marginRight: '15px',
    height: '70px',
    width: '70px',
    borderRadius: '50%',
  },
});

export default useStyles;
